var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.18096,
    cy: 6.41704,
    r: 5.62017,
    fill: "#042F46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.266621 19.8523C0.265111 19.4572 0.353472 19.0669 0.525019 18.711C1.06335 17.6344 2.58144 17.0637 3.84113 16.8053C4.74962 16.6114 5.67066 16.4819 6.59739 16.4177C8.31315 16.267 10.0388 16.267 11.7546 16.4177C12.6812 16.4827 13.6022 16.6122 14.5108 16.8053C15.7705 17.0637 17.2886 17.5805 17.827 18.711C18.1719 19.4365 18.1719 20.2788 17.827 21.0043C17.2886 22.1348 15.7705 22.6516 14.5108 22.8992C13.6034 23.1011 12.6821 23.2343 11.7546 23.2976C10.3581 23.416 8.95509 23.4376 7.55561 23.3622C7.23262 23.3622 6.92038 23.3622 6.59739 23.2976C5.6734 23.2351 4.75555 23.1019 3.8519 22.8992C2.58144 22.6516 1.07412 22.1348 0.525019 21.0043C0.354348 20.6443 0.266075 20.2507 0.266621 19.8523Z",
    fill: "#042F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProfile);
export default __webpack_public_path__ + "static/media/headerProfile.83de7f011b4d062aa3524850e8aa5189.svg";
export { ForwardRef as ReactComponent };